import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../common/user.service';
import {MdSnackBar} from '@angular/material';
import { Router, ActivatedRoute, Params} from '@angular/router';
import { EventService } from '../../admin/event.service';
import { CountryService } from '../../common/country.service';
import { ExcursionService } from '../../common/excursion.service';
import { CreditService } from '../../common/credit.service';
import { PageService } from '../../common/page.service';
import {MdDialog} from '@angular/material';
import {LoginComponent} from '../../home/login/login.component';
import {TextMaskModule} from 'angular2-text-mask';
import {IMyDpOptions} from 'mydatepicker';
import { AppSettings } from '../../app-settings'

@Component({
  selector: 'trip-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css', '../../app.component.css'],
  providers: [ EventService, UserService, CountryService, ExcursionService, CreditService, PageService ]
})

export class TripRegistrationComponent implements OnInit {

 CONTACT_EMAIL = AppSettings.CONTACT_EMAIL
 CONTACT_NAME = AppSettings.CONTACT_NAME


 public scrollTop = 0;

 //constructor(@Inject(DOCUMENT) private document: any) { }

 @HostListener('window:scroll', [])

 onWindowScroll() {
  this.scrollTop = this.document.scrollingElement.scrollTop;
 }

  eventId = 0;
  event: any;
  eventPages: any;
  selectedTab = 0;
  currentStep = 1;
  users = [];
  countries: any;
  states: any;
  excursions = [];
  billingAddress = {
   name : '',
   line1 : '',
   line2 : '',
   city : '',
   stateId : '',
   state : '',
   countryId : '',
   country : '',
   zipcode : '',
   sameAsUser : false
  };
  billingStates: any;
  creditCard = {
   name : '',
   number : '',
   expMonth : '',
   expYear : '',
   cvv : '',
   type : undefined,
   save : false
  };
  regId = '';
  transactionId = '';
  spinner: boolean = false;
  payType = 'Card';
  personalForm: any;
  attendeeForm: any;
  benefits = '';
  phoneMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  todayDate = new Date();
  public myDatePickerOptions: IMyDpOptions = {
   dateFormat: 'mm/dd/yyyy',
   disableSince: {year: this.todayDate.getFullYear(), month: this.todayDate.getMonth()+1, day: this.todayDate.getDate()+1}
  };

public model: any = { date: { year: 2018, month: 10, day: 9 } };

  constructor(@Inject(DOCUMENT) private document: any, private eventService: EventService, private userService:  UserService, private snackBar: MdSnackBar, private activatedRoute: ActivatedRoute, private countryService: CountryService, private excursionService: ExcursionService, private router:Router, public dialog: MdDialog, private creditService: CreditService, private pageService: PageService, private titleService: Title){
  }

  ngOnInit(){
   this.initiate();
   this.titleService.setTitle('Trip Registration');
  }

  initiate(){
   this.eventId = this.activatedRoute.root.firstChild.snapshot.data['eventId'];
   if(!this.eventId)
   {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
     this.eventId = params.eventId;
    });
   }
   this.getBenefits();
   this.users[0] = {
    userId : '',
    firstName : '',
    lastName : '',
    email : '',
    cellPhone : '',
    password : '',
    rePassword : '',
    eventUser : {
     eventId : this.eventId,
     userId : '',
     badgeName : '',
     firstName : '',
     lastName : '',
     cellPhone : '',
     companyName : '',
     addressLine1 : '',
     addressLine2 : '',
     countryId : '',
     stateId : '',
     stateName : '',
     countryName : '',
     city : '',
     zipcode : '',
     workPhone : '',
     extension : '',
     type : 'Trip',
     designation : 'Main User',
     arriveByPlane : 1,
     arriveFlightName : '',
     arriveFlightNumber : '',
     arriveDateTime : '',
     arriveDateTime_ : '',
     arriveNames : '',
     arrivalTime:'',
     returnFlightName : '',
     returnFlightNumber : '',
     returnDateTime : '',
     returnDateTime_ : '',
     returnNames : '',
     returnTime:'',
     attendAwardCelebration : 1,
     userExcursions : [],
     price : 0.00,
     transId : '123',
     contribution : '0',
     mealRestriction : 0,
     mealChoice : 0,
     mealComments : '',
     title : '',
     emergencyPhone : '',
     checkIn : '',
     checkOut : '',
     roomType : '',
     roomTypeComments : '',
     beddingPreference : '',
     dob : '',
     dob_ : '',
    }
   };
   this.eventService.getEvents({eventId:this.eventId}).subscribe(response => {
    this.event = response[0];
    this.event.not_started = parseInt(this.event.not_started);
    this.event.reg_ended = parseInt(this.event.reg_ended);
    this.event.obtainTravel = parseInt(this.event.obtainTravel);
    if(this.event.not_started)
    {
     this.snackBar.open('Registration not started','',{duration:4000});
     this.router.navigate(['/home']);
    }
    if(this.event.reg_ended)
    {
     this.snackBar.open('Registration ended already','',{duration:4000});
     this.router.navigate(['/home']);
    }
   });
   this.pageService.getPages(this.eventId).subscribe(response => {
    this.eventPages = response;
    var pages = [];
    for(var i=0;i<this.eventPages.length;i++)
    if((this.eventPages[i].displayFor=='Trip' || this.eventPages[i].displayFor=='Both') && this.eventPages[i].publish==1)
    pages.push(this.eventPages[i]);
    this.selectedTab = this.eventPages.length;
   });
   this.countryService.getCountries().subscribe(response => {
    this.countries = response;
    for(var i=0;i<this.countries.length;i++)
    if(this.countries[i].name=='USA')
    {
     this.users[0].eventUser.countryId = this.countries[i].id;
     this.countryChanged({apply:1});
     this.billingAddress.countryId = this.countries[i].id;
     this.billingCountryChanged();
    }
   });
   this.excursionService.getExcursions(this.eventId).subscribe(response => {
    this.excursions = response;
    this.assignUserExcursions(this.users[0]);
    if(this.users.length==1)
    this.addAttendee();
   });
  }

  makeCurrent(step){
   if(!this.regId)
   {
    this.currentStep = step;
    window.scrollTo(0,0);
    if(step==2 && this.users.length==1)
    this.addAttendee();
   }
  }

  register(personalForm,attendeeForm){
   this.spinner = true;
   if(!personalForm.valid)
   this.makeCurrent(1);
   else if(!attendeeForm.valid)
   this.makeCurrent(2);
   else
   {
    for(var i=0;i<this.users.length;i++)
    {
     this.users[i].eventUser.arriveDateTime = this.toSqlTime(this.users[i].eventUser.arriveDateTime);
     this.users[i].eventUser.returnDateTime = this.toSqlTime(this.users[i].eventUser.returnDateTime);
     this.users[i].eventUser.checkIn = this.toSqlTime(this.users[i].eventUser.checkIn);
     this.users[i].eventUser.checkOut = this.toSqlTime(this.users[i].eventUser.checkOut);
     //this.users[i].eventUser.dob = this.dateTimeFormat(this.users[i].eventUser.dob_);
    }
    var usrs = [this.users[0]];
    this.userService.registerTrip({ event:this.event, users:usrs.concat(this.activeUsers()), payTotal:this.totalFee(), payType:this.payType }).subscribe(
     response => {
      this.spinner = false;
      if(response.status)
      {
       this.snackBar.open('User Registered Successfully','',{duration:4000});
       this.makeCurrent(4);
       this.regId = response.regId;
       this.transactionId = (response.transactionId && typeof(response.transactionId)=='object'?response.transactionId[0]:response.transactionId);
       this.userService.registerTripMail({ mailData:response.mailData }).subscribe();
      }
      else
      this.snackBar.open(response.msg,'',{duration:4000});
     },
     error => {
      this.spinner = false;
      this.makeCurrent(4);
      this.snackBar.open(error,'',{duration:4000});
     }
    );
   }
  }

  countryChanged(params){
   this.spinner = true;
   this.countryService.getStates(this.users[0].eventUser.countryId).subscribe(
    response => {
     this.spinner = false;
     this.states = response;
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error,'',{duration:4000});
    }
   );
   if(params.apply)
   {
    for(var i=0;i<this.countries.length;i++)
    if(this.countries[i].id==this.users[0].eventUser.countryId)
    this.users[0].eventUser.countryName = this.countries[i].name;
   }
  }

  stateChanged(){
   for(var i=0;i<this.states.length;i++)
   if(this.states[i].id==this.users[0].eventUser.stateId)
   this.users[0].eventUser.stateName = this.states[i].name;
  }

  billingCountryChanged(){
   this.spinner = true;
   this.countryService.getStates(this.billingAddress.countryId).subscribe(
    response => {
     this.spinner = false;
     this.billingStates = response;
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error,'',{duration:4000});
    }
   );
   for(var i=0;i<this.countries.length;i++)
   if(this.countries[i].id==this.billingAddress.countryId)
   this.billingAddress.country = this.countries[i].name;
  }

  billingStateChanged(){
   for(var i=0;i<this.billingStates.length;i++)
   if(this.billingStates[i].id==this.billingAddress.stateId)
   this.billingAddress.state = this.billingStates[i].name;
  }

  dateTimeFormat(dt){
   if(dt)
   {
    var m = dt.getMonth()+1;
    if(m<10)
    m='0'+m;
    var d = dt.getDate();
    if(d<10)
    d='0'+d;
    return dt.getFullYear()+'-'+m+'-'+d+' 00:00:00';
   }
   else
   return '';
  }

  usDateTimeFormat(dt){
   if(dt)
   {
    if(typeof dt=='string')
    {
     dt = dt.split(' ');
     dt = dt[0].split('-');
     return dt[1]+'/'+dt[2]+'/'+dt[0];
    }
    else
    {
     var m = dt.getMonth()+1;
     if(m<10)
     m='0'+m;
     var d = dt.getDate();
     if(d<10)
     d='0'+d;
     return m+'/'+d+'/'+dt.getFullYear();
    }
   }
   else
   return '';
  }

  toSqlTime(dt){
   var s = '';
   if(dt)
   {
    if(typeof(dt)=='object')
    {
     s += dt._d.toLocaleDateString();
     s += ' ';
     s += dt._d.toTimeString().split(' ')[0];
    }
    else
    return dt;
   }
   return s;
  }

  toUsSqlTime(dt){
   var s = '';
   if(dt)
   {
    if(typeof(dt)=='object')
    {
     s += dt._d.toLocaleDateString();
     s += ' ';
     s += dt._d.toLocaleTimeString();
    }
    else
    return dt;
   }
   return s;
  }

  excursionSelected(userExcursion){
   this.spinner = true;
   userExcursion.userQuestions = [];
   userExcursion.questions = [];
   if(userExcursion.checked)
   {
    for(var i=0;i<this.excursions.length;i++)
    if(this.excursions[i].id==userExcursion.excursionId)
    {
     userExcursion.excursionName = this.excursions[i].name;
     break;
    }
    this.excursionService.getExcursionQuestionsWithOptions({excursionId:userExcursion.excursionId}).subscribe(
     response => {
      this.spinner = false;
      userExcursion.questions = response;
      userExcursion.userQuestions = [];
      for(var i=0;i<userExcursion.questions.length;i++)
      {
       userExcursion.questions[i].isMandatory = parseInt(userExcursion.questions[i].isMandatory);
       userExcursion.userQuestions.push({id:'', userId:userExcursion.userId, excursionQuestionId:userExcursion.questions[i].id, answerId:0, answerText:''});
       for(var j=0;j<userExcursion.questions[i].options.length;j++)
       for(var k=0;k<userExcursion.questions[i].options[j].questions.length;k++)
       userExcursion.questions[i].options[j].questions[k].isMandatory = parseInt(userExcursion.questions[i].options[j].questions[k].isMandatory);
      }
     },
     error => {
      this.spinner = false;
     }
    );
   }
   else
   this.spinner = false;
  }

  optionSelected(params){
   for(var i=0;i<params.question.options.length;i++)
   {
    if(params.question.options[i].id==params.optionId && (params.userExcursion.userQuestions[params.questionIndex].answerId==params.optionId || params.question.options[i].selected))
    {
     params.question.options[i].userQuestions = [];
     for(var j=0;j<params.question.options[i].questions.length;j++)
     params.question.options[i].userQuestions.push({id:'', userId:params.userExcursion.userId, excursionQuestionId:params.question.options[i].questions[j].id, answerId:0, answerText:''});
    }
   }
   if(params.userExcursion.price)
   this.setPrice(params);
  }

  setPrice(params){
   params.userExcursion.userQuestions[params.questionIndex].price = 0.00;
   for(var i=0;i<params.question.options.length;i++)
   {
    for(var j=0;j<params.question.options[i].userQuestions.length;j++)
    params.question.options[i].userQuestions[j].price = 0.00;
    if(params.userExcursion.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
    {
     if(params.question.options[i].isPrice)
     {
      if(params.question.answerType=='Radio')
      params.userExcursion.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
      else if(params.question.answerType=='Check')
      params.userExcursion.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
     }
    }
   }
  }

  subOptionSelected(params){
   if(params.userExcursion.price)
   this.setSubPrice(params)
  }

  setSubPrice(params){
   params.option.userQuestions[params.questionIndex].price = 0.00;
   for(var i=0;i<params.question.options.length;i++)
   {
    if(params.option.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
    {
     if(params.question.options[i].isPrice)
     {
      if(params.question.answerType=='Radio')
      params.option.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
      else if(params.question.answerType=='Check')
      params.option.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
     }
    }
   }
  }

  featureOptionSelected(params){
   this.setFeaturePrice(params);
  }

  setFeaturePrice(params){
   params.userFeature.price = 0.00;
   for(var i=0;i<params.feature.options.length;i++)
   {
    if(params.userFeature.answerId==params.feature.options[i].id || params.feature.options[i].selected)
    {
     if(params.feature.options[i].isPrice)
     {
      if(params.feature.answerType=='Radio')
      params.userFeature.price = parseFloat(params.feature.options[i].price);
      else if(params.feature.answerType=='Check')
      params.userFeature.price += parseFloat(params.feature.options[i].price);
     }
    }
   }
  }

  attendees(){
   var attendees = [];
   for(var i=1;i<this.users.length;i++)
   attendees.push(this.users[i]);
   return attendees;
  }

  addAttendee(){
   this.users.push({
    userId : '',
    firstName : '',
    lastName : '',
    email : '',
    cellPhone : '',
    password : '',
    rePassword : '',
    eventUser : {
     eventId : this.eventId,
     userId : '',
     badgeName : '',
     firstName : '',
     lastName : '',
     cellPhone : '',
     companyName : '',
     addressLine1 : '',
     addressLine2 : '',
     countryId : '',
     stateId : '',
     city : '',
     zipcode : '',
     workPhone : '',
     extension : '',
     type : 'Trip',
     designation : 'Guest',
     arriveByPlane : 1,
     arriveFlightName : '',
     arriveFlightNumber : '',
     arriveDateTime : '',
     arriveDateTime_ : '',
     arriveNames : '',
     returnFlightName : '',
     returnFlightNumber : '',
     returnDateTime : '',
     returnDateTime_ : '',
     returnNames : '',
     attendAwardCelebration : 1,
     userExcursions : [],
     price : 0.00,
     mealRestriction : 0,
     mealChoice : 0,
     mealComments : '',
     title : '',
     emergencyPhone : '',
     checkIn : '',
     checkOut : '',
     roomType : '',
     roomTypeComments : '',
     beddingPreference : '',
     dob : '',
     dob_ : ''
    }
   });
   this.assignUserExcursions(this.users[this.users.length-1]);
  }

  deleteUser(i){
   if(confirm('Are you sure?'))
   {
    //this.users.splice(i,1);
    this.users[i].deleted = true;
    this.checkUserPrice();
   }
  }

  checkUserPrice(){
   var usrCnt = 0;
   for(var i=1;i<this.users.length;i++)
   {
    if(!this.users[i].deleted)
    usrCnt += 1;
    this.users[i].eventUser.price = 0.00;
   }
  }

  notValid(frm){
  }

  assignUserExcursions(user){
   user.eventUser.userExcursions = [];
   for(var i=0;i<this.excursions.length;i++)
   user.eventUser.userExcursions.push({
    userId : '',
    eventId : user.eventUser.eventId,
    excursionId : this.excursions[i].id,
    checked : false,
    questions : [],
    userQuestions : []
   });
  }

  userFee(i){
   var price = parseFloat(this.users[i].eventUser.price);
   price += parseFloat(this.excursionFee(i));
   return price;
  }

  excursionFee(i){
   return '0.00';
  }

  totalFee(){
   var price = 0.00;
   for(var i=0;i<this.users.length;i++)
   if(!this.users[i].deleted)
   price += this.userFee(i);
   if(!isNaN(parseFloat(this.users[0].eventUser.contribution)))
   price += parseFloat(this.users[0].eventUser.contribution);
   this.users[0].eventUser.totalPrice = price;
   return price.toFixed(2);
  }

  subTotal(){
   var subTotal = parseFloat(this.totalFee())-(!isNaN(parseFloat(this.users[0].eventUser.contribution)) ? parseFloat(this.users[0].eventUser.contribution) : 0);
   return subTotal.toFixed(2);
  }

  billingSameAsUser(){
   this.spinner = true;
   if(this.billingAddress.sameAsUser)
   {
    this.billingAddress.name = this.users[0].eventUser.companyName;
    this.billingAddress.line1 = this.users[0].eventUser.addressLine1;
    this.billingAddress.line2 = this.users[0].eventUser.addressLine2;
    this.billingAddress.city = this.users[0].eventUser.city;
    this.billingAddress.stateId = this.users[0].eventUser.stateId;
    this.billingAddress.state = this.users[0].eventUser.stateName;
    this.billingAddress.countryId = this.users[0].eventUser.countryId;
    this.countryService.getStates(this.users[0].eventUser.countryId).subscribe(
     response => {
      this.spinner = false;
      this.billingStates = response;
     },
     error => {
      this.spinner = false;
     }
    );
    this.billingAddress.country  = this.users[0].eventUser.countryName;
    this.billingAddress.zipcode = this.users[0].eventUser.zipcode;
   }
   else
   {
    this.spinner = false;
    this.billingAddress.name = '';
    this.billingAddress.line1 = '';
    this.billingAddress.line2 = '';
    this.billingAddress.city = '';
    this.billingAddress.stateId = '';
    this.billingAddress.state = '';
    this.billingAddress.countryId = '';
    this.billingAddress.country = '';
    this.billingAddress.zipcode = '';
   }
  }

  skipAttendees(){
   this.users.splice(1);
   this.makeCurrent(3);
  }

  print(){
   window.print();
  }

  loginDialog() {
    let dialogRef = this.dialog.open(LoginComponent);
    dialogRef.componentInstance.onLogin.subscribe(() => {
     dialogRef.close();
    });
  }

  cardType(){
   return this.creditService.parseCardType(this.creditCard.number);
  }

  personalFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   if(flag && this.users[0].password!=this.users[0].rePassword)
   flag = false;
   if(flag && !this.validateEmail(this.users[0].email))
   flag = false;
   if(flag && !this.validatePhone(this.users[0].eventUser.cellPhone))
   flag = false;
   if(flag && !this.validateZip(this.users[0].eventUser.zipcode,this.users[0].eventUser.countryName))
   flag = false;
   if(flag)
   {
    this.users[0].eventUser.userExcursions.forEach(function(userExcursion){
     if(userExcursion.checked)
     {
      for(var i=0;i<userExcursion.questions.length;i++)
      {
       if(!flag)
       break;
       if(userExcursion.questions[i].isMandatory==1 && (userExcursion.questions[i].answerType=='TextField' || userExcursion.questions[i].answerType=='Radio') && !(userExcursion.userQuestions[i].answerText || userExcursion.userQuestions[i].answerId>0))
       flag = false;
       for(var j=0;j<userExcursion.questions[i].options.length;j++)
       {
        if(!flag)
        break;
        if(userExcursion.questions[i].options[j].id!=userExcursion.userQuestions[i].answerId)
        continue;
        for(var k=0;k<userExcursion.questions[i].options[j].questions.length;k++)
        {
         if(!flag)
         break;
         if(!userExcursion.questions[i].options[j].userQuestions[k])
         continue;
         if(userExcursion.questions[i].options[j].questions[k].isMandatory==1 && (userExcursion.questions[i].options[j].questions[k].answerType=='TextField' || userExcursion.questions[i].options[j].questions[k].answerType=='Radio') && !(userExcursion.questions[i].options[j].userQuestions[k].answerText || userExcursion.questions[i].options[j].userQuestions[k].answerId>0))
         flag = false;
        }
       }
      }
     }
    });
   }
   if(!flag)
   {
    window.scrollTo(0,0);
    this.snackBar.open('Please fill all mandatory fields marked with *','',{duration:4000});
   }
   return flag;
  }

  attendeeFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   for(var i=1;i<this.users.length;i++)
   {
    if(this.users[i].deleted)
    continue;
    if(flag && this.users[i].password!=this.users[i].rePassword)
    {
     flag = false;
     break;
    }
    if(flag && this.users[i].email && !this.validateEmail(this.users[i].email))
    {
     flag = false;
     break;
    }
    if(flag && this.users[i].eventUser.cellPhone && !this.validatePhone(this.users[i].eventUser.cellPhone))
    {
     flag = false;
     break;
    }
    if(flag)
    {
     this.users[i].eventUser.userExcursions.forEach(function(userExcursion){
      if(userExcursion.checked)
      {
       for(var j=0;j<userExcursion.questions.length;j++)
       {
        if(!flag)
        break;
        if(userExcursion.questions[j].isMandatory==1 && (userExcursion.questions[j].answerType=='TextField' || userExcursion.questions[j].answerType=='Radio') && !(userExcursion.userQuestions[j].answerText || userExcursion.userQuestions[j].answerId>0))
        flag = false;
        for(var k=0;k<userExcursion.questions[j].options.length;k++)
        {
         if(!flag)
         break;
         if(userExcursion.questions[j].options[k].id!=userExcursion.userQuestions[j].answerId)
         continue;
         for(var l=0;l<userExcursion.questions[j].options[k].questions.length;l++)
         {
          if(!flag)
          break;
          if(!userExcursion.questions[j].options[k].userQuestions[l])
          continue;
          if(userExcursion.questions[j].options[k].questions[l].isMandatory==1 && (userExcursion.questions[j].options[k].questions[l].answerType=='TextField' || userExcursion.questions[j].options[k].questions[l].answerType=='Radio') && !(userExcursion.questions[j].options[k].userQuestions[l].answerText || userExcursion.questions[j].options[k].userQuestions[l].answerId>0))
          flag = false;
         }
        }
       }
      }
     });
    }
   }
   if(!flag)
   {
    window.scrollTo(0,0);
    this.snackBar.open('Please fill all mandatory fields marked with *','',{duration:4000});
   }
   return flag;
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  
  validatePhone(phone){
   //var re1 = /^[0-9]{10}$/;
   //var re2 = /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
   //return (re1.test(phone) || re2.test(phone));
   var re = /^[0-9]{10}$/;
   return re.test(phone.replace(/-/g, ""));
  }

  validateZip(zip,country){
    return true;
  //  if(country=='Canada')
  //  var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
  //  else
  //  var re = /^\d{5}(-\d{4})?$/;
  //  return re.test(zip);
  }

  validateDigit(num,min,max){
   return num.match("^[0-9]{"+min+","+max+"}$");
  }

  tabChanged($event: any, personalForm, attendeeForm){
   //this.selectedTab = $event.index;
   if($event.tab.textLabel!='Registration Form')
   this.resetPage(personalForm,attendeeForm);
  }

  resetPage(personalForm,attendeeForm){
   this.users = [];
   this.regId = '';
   this.transactionId = '';
   this.payType = 'Card';
   this.makeCurrent(1);
   this.excursions = []
   this.billingAddress = {
    name : '',
    line1 : '',
    line2 : '',
    city : '',
    stateId : '',
    state : '',
    countryId : '',
    country : '',
    zipcode : '',
    sameAsUser : false
   };
   this.billingStates = []
   this.creditCard = {
    name : '',
    number : '',
    expMonth : '',
    expYear : '',
    cvv : '',
    type : undefined,
    save : false
   };
   this.initiate();
  }

  negativeCheck(){
   if(isNaN(this.users[0].eventUser.contribution) || parseFloat(this.users[0].eventUser.contribution)<0)
   this.users[0].eventUser.contribution = 0;
  }

  isNonFreeFeature(feature){
   var flag = true;
   return flag;
  }

  activeUsers(){
   var u = [];
   for(var i=1;i<this.users.length;i++)
   if(!this.users[i].deleted)
   u.push(this.users[i]);
   return u;
  }

  activeIndex(index){
   var indx = 0;
   for(var i=0;i<index;i++)
   if(!this.users[i].deleted)
   indx += 1;
   return indx;
  }

  triggerClick(id){
   (<HTMLInputElement>window.document.getElementById(id)).click()
  }

  selectedExcursions(user){
   var excs = [];
   user.eventUser.userExcursions.forEach(function(userExcursion){
    if(userExcursion.checked)
    excs.push(userExcursion.excursionName);
   });
   return excs.join(', ');
  }

  getBenefits(){
   this.spinner = true;
   this.eventService.getBenefits({eventId: this.eventId}).subscribe(
    response => {
     this.spinner = false;
     this.benefits = response;
    },
    error => {
     this.spinner = false;
    }
   );
  }

  validateDate(dt){
   if(!dt)
   return false;
   dt = new Date(dt);
   return (dt!='Invalid Date');
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/trip/registration/registration.component.ts